(() => {
  // app/scripts/swatch-choice.js
  !customElements.get("swatch-choice") && customElements.define("swatch-choice", class extends HTMLElement {
    connectedCallback() {
      this.addEventListener("change", (e) => {
        e.target.closest("input") && this.onVariantChange();
      });
      window.addEventListener("DOMContentLoaded", () => {
        document.querySelector("sticky-component .swatch-btn-trigger").addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.addItemToCart();
        });
      });
    }
    get getCheckedList() {
      return [...this.querySelectorAll('[type="checkbox"]:checked')];
    }
    async addItemToCart() {
      const listId = this.getCheckedList.map((item) => {
        return { id: item.value };
      });
      if (!listId.length)
        return;
      let response = await fetch(`${this.dataset.url}/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json;" },
        body: JSON.stringify({ items: listId, sections: [this.dataset.sections], section_url: location.pathname })
      });
      response = await response.json();
      document.dispatchEvent(new CustomEvent("cart:build"));
      document.querySelector(".js-drawer-open-cart")?.click();
    }
    show() {
      this.isReadyToShow && this.classList.add("active");
    }
    onVariantChange() {
      let desc = "";
      let price = 0;
      this.getCheckedList.forEach((input) => {
        desc += input.dataset.msg;
        price += +input.dataset.price;
      });
      const div = document.createElement("div");
      div.className = "swatch-desc";
      div.innerHTML = desc;
      document.querySelector(".swatch-desc")?.remove();
      document.querySelector("sticky-component").insertAdjacentElement("afterend", div);
      let oldPrice = price;
      let discountAmount = this.getCheckedList.length * +this.dataset.discountAmount;
      price -= this.getCheckedList.length > 1 ? discountAmount : 0;
      document.querySelector(".js-productPrice .product__price").innerHTML = theme.Currency.formatMoney(price, theme.settings.moneyFormat);
    }
  });
  document.body.addEventListener("click", (e) => {
    if (e.target.closest(".bcpo-modal-parent") && document.querySelector("swatch-choice"))
      document.querySelector("swatch-choice").isReadyToShow = true;
  });
})();
